import { render } from "./enquiries-list.vue?vue&type=template&id=3b52a1c0"
import script from "./enquiries-list.vue?vue&type=script&lang=js"
export * from "./enquiries-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__